

























































import { Vue, Component } from 'vue-property-decorator'
import CAudio from './component/CAudio.vue'
import { getDetailA } from '@/server/phpApi'
import { constants } from 'http2'
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
])
@Component({
  components: {
    CAudio,
  },
})
export default class Detail extends Vue {
  detail: any = {
    phone: '',
    detail: '',
    grade_name: '',
    audio: '',
    play: false,
  }
  recordList: any = []
  isBack: boolean = true
  beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      if (from.name !== 'customerlist') {
        vm.$data.isBack = false
      }
    })
  }
  handleGoBack() {
    if (this.isBack) {
      this.$router.back()
    } else {
      this.$router.push('/customerlist')
    }
  }
  getDetail(taskId: string, phone: string) {
    getDetailA({
      taskId,
      phone,
    }).then(res => {
      if (res.code === 200) {
        const resData: any = res.data
        this.detail.phone = resData.phone
        this.detail.audio = resData.audio
        this.recordList = JSON.parse(resData.detail)
        for (let item of this.recordList) {
          item.playing = false
        }
      }
    })
  }

  handleLoadedMetaData(audioRef: string, item: any, index: number) {
    const audio: any = this.$refs[audioRef]
    const audioNode = audio[0]
    const currentTime = Math.floor(item.offset / 1000.0)
    const duration = Math.ceil(item.duration / 1000.0)
    audioNode.currentTime = currentTime
    audioNode.addEventListener('timeupdate', () => {
      if (audioNode.currentTime > duration) {
        audioNode.pause()
        item.playing = false
        this.recordList.push({item})
      }
    })
  }
  turnApartIconPaused() {
    for (let i = 0; i < this.recordList.length; i++) {
      this.recordList[i].playing = false
    }
  }
  handleWholeStart() {
    const audioNodes: any = document.getElementsByClassName('part-audio')
    for (let i = 0; i < audioNodes.length; i++) {
      audioNodes[i].pause()
    }
    this.turnApartIconPaused()
  }
  handlePlayApart(audioRef: string, item: any, index: number) {
    const audio: any = this.$refs[audioRef]
    const audioNode = audio[0]
    const currentTime = Math.floor(item.offset / 1000.0)
    const duration = Math.ceil(item.duration / 1000.0)
    audioNode.currentTime = currentTime
    console.log(currentTime, item.offset, duration, item.duration)
    this.turnApartIconPaused()
    if (audioNode.paused) {
      const allAudio = document.getElementsByTagName('audio')
      for (let i = 0; i < allAudio.length; i++) {
        allAudio[i].pause()
      }
      audioNode.play()
      item.playing = true
      this.recordList.push({item})
    } else {
      audioNode.pause()
      item.playing = false
      this.recordList.push({item})
    }
  }
  created() {
    const taskId = this.$route.params.taskId
    const phone = this.$route.params.phone
    this.getDetail(taskId, phone)
  }
}
